import React from "react";

const STATUS = {
  new: ["New", "text-cyan-300 bg-cyan-500/15 border-cyan-500/30"],
  open: ["Open", "text-blue-300 bg-blue-500/15 border-blue-500/30"],
  waiting_customer: ["Waiting for customer", "text-amber-300 bg-amber-500/15 border-amber-500/30"],
  in_progress: ["In progress", "text-violet-300 bg-violet-500/15 border-violet-500/30"],
  escalated: ["Escalated", "text-rose-300 bg-rose-500/15 border-rose-500/30"],
  resolved: ["Resolved", "text-emerald-300 bg-emerald-500/15 border-emerald-500/30"],
  closed: ["Closed", "text-ink-muted bg-bg-elevated border-line"],
};

const PRIORITY = {
  low: ["Low", "text-ink-muted"],
  normal: ["Normal", "text-cyan-300"],
  high: ["High", "text-amber-300"],
  urgent: ["Urgent", "text-rose-300"],
};

export const StatusBadge = ({ status }) => {
  const [label, cls] = STATUS[status] || STATUS.new;
  return (
    <span data-testid={`ticket-status-${status}`}
      className={`inline-flex font-mono text-[9px] uppercase tracking-wider px-2 py-0.5 rounded border ${cls}`}>
      {label}
    </span>
  );
};

export const PriorityBadge = ({ priority }) => {
  const [label, cls] = PRIORITY[priority] || PRIORITY.normal;
  return (
    <span className={`inline-flex items-center gap-1 font-mono text-[9px] uppercase tracking-wider ${cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />{label}
    </span>
  );
};
